import { IconAdjustmentsOptions } from '../icon-adjustments-options';
import { MemorySearchSettings } from '../memory-search-client/memory-search-client';

export interface ResourceMemorySourceSettings extends MemorySearchSettings {
  iconAdjustments?: IconAdjustmentsOptions;
}
